import type { PageRequest } from '@/models/listPage';

export interface RequestFilters {
  /** Inutilisée (pas de recherche sur ses propres demandes) : requise par useListControls */
  search: string;
  /** Référence du statut (VALIDATED…) ; null : tous */
  timeSheetStatus: string | null;
}

/** Filtres à l'arrivée sur Mes demandes : aucun */
export const DEFAULT_REQUEST_FILTERS: RequestFilters = { search: '', timeSheetStatus: null };

/**
 * Requête GET /time_sheets d'une page de Mes demandes : les feuilles de l'employé dans la société sélectionnée (son
 * Member), brouillon compris, de la plus récente période à la plus ancienne. null : pas employé de la société.
 */
export function buildRequestListRequest(
  memberId: number | null,
  { timeSheetStatus }: RequestFilters,
  page: number,
  itemsPerPage: number,
  /** Id API du statut (liste chargée depuis l'API) */
  statusId: (reference: string) => number | null = () => null,
): PageRequest | null {
  if (!memberId) return null;

  return {
    filters: {
      member: memberId,
      timeSheetStatus: timeSheetStatus ? statusId(timeSheetStatus) : null,
    },
    order: { 'period.month': 'desc' },
    page,
    itemsPerPage,
  };
}
